/**
 * Usage Hooks
 *
 * React Query hooks for fetching and caching user usage statistics.
 */

import { useQuery } from "@tanstack/react-query";
import { getUserUsage } from "../services/usageService";
import type { UserUsage } from "../types/usage";

/**
 * Hook to fetch current user's usage statistics
 */
export function useUserUsage() {
  return useQuery<UserUsage, Error>({
    queryKey: ["userUsage"],
    queryFn: getUserUsage,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
